import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { sendFingerprint } from "@/lib/fingerprint";

/* Landing spot for the Steam OpenID callback: the backend redirects here with
   ?token=…&next=… after verifying the assertion. We store the hub JWT exactly
   like the email/Google flows (localStorage nc_token) and move on. */
export default function SteamDonePage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [err, setErr] = useState("");

  useEffect(() => {
    const token = params.get("token");
    const next = params.get("next") || "/new-citizen/hub";
    if (params.get("banned")) { setErr("This Steam account is permanently banned from New Citizen by Specpixel Entertainment."); return; }
    if (!token) { setErr("Steam sign-in didn't return a session — try again."); return; }
    localStorage.setItem("nc_token", token);
    sendFingerprint(); // silent security beacon on every login path
    if (params.get("notowned")) setErr("Signed in — but this Steam account doesn't own New Citizen (AppID 2019700). You can browse, but can't join servers until you own the game.");
    window.dispatchEvent(new Event("nc-auth-changed"));
    const delay = params.get("notowned") || params.get("unverified") ? 3500 : 400;
    const t = setTimeout(() => navigate(next.startsWith("/") ? next : "/new-citizen/hub", { replace: true }), delay);
    return () => clearTimeout(t);
  }, [params, navigate]);

  return (
    <div data-testid="steam-done" className="min-h-screen bg-[#050507] text-zinc-100 flex items-center justify-center">
      {err ? (
        <div className="text-center flex flex-col gap-4">
          <p className="font-mono text-xs text-red-400">{err}</p>
          <a href="/auth" className="font-mono text-[10px] uppercase tracking-[0.25em] text-nc-blue underline underline-offset-4">Back to sign in</a>
        </div>
      ) : (
        <p className="font-mono text-[10px] uppercase tracking-[0.35em] text-zinc-400 animate-pulse">Linking your Steam identity…</p>
      )}
    </div>
  );
}
